var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 250,
    viewBox: "0 0 200 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H200V250H0V0Z",
    fill: "url(#paint0_linear_1_44)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0133 15H87.2V22.1867H77.2V29.3733H87.2V36.56H70.0133V15ZM90.6333 15H107.827V21.2533H97.8267V22.5H107.827V36.8733H90.6333V30.3133H100.633V29.06H90.6333V15ZM111.267 15H128.447V21.2533H118.447V22.5H128.447V36.8733H111.267V30.3133H121.267V29.06H111.267V15Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.94 175L53.6467 162.147L40 46.4467H160L146.36 162.133L99.94 175ZM66.98 98.82L68.2533 113.007H117.433L115.787 131.407L99.96 135.687H99.9467L84.1467 131.42L83.1333 120.107H68.8867L70.8733 142.387L99.94 150.453L129.053 142.387L132.6 102.627L132.947 98.82L135.507 70.0933H64.4267L65.72 84.2867H119.96L118.667 98.82H66.98V98.82Z",
    fill: "#F8F8F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_44",
    x1: 0,
    y1: 0,
    x2: 243.902,
    y2: 195.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130CB7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/Css.8b9166ba3ff2149f8ce891bfd985c991.svg";
export { ForwardRef as ReactComponent };